import {
    EditButton, TopToolbar, ListButton
} from 'react-admin';

export const ShowActions = ({ data }) => (
    <TopToolbar>
        <EditButton record={data} />
        <ListButton />
    </TopToolbar>
);